"use client";
import Card from "react-bootstrap/Card";
import common from "../../utils/common";
import moment from "moment";
import { Badge, Col, Row, Stack } from "react-bootstrap";
import { cal_calendar, cal_record } from "../../class/prisma/db";
import { PiDotsThree } from "react-icons/pi";

type EventCardProps = {
  title?: string;
  events?: cal_record[];
  bootstrapVariant?:
    | "primary"
    | "secondary"
    | "success"
    | "danger"
    | "warning"
    | "info"
    | "light"
    | "dark";
  calendarData?: cal_calendar[];
};

function EventCard({
  title = "Upcoming Events",
  events,
  calendarData,
  bootstrapVariant,
}: EventCardProps) {
  const applyCalendarColor = (node: HTMLSpanElement, calendarId: number) => {
    if (!node || !node?.style) {
      return;
    }
    if (!calendarData || calendarData.length === 0) {
      return;
    }
    if (calendarId === null || calendarId === undefined || calendarId <= 0) {
      return;
    }
    const calendar = calendarData.find((c) => c.id === calendarId);
    if (!calendar) {
      return;
    }
    node.style.setProperty(
      "background-color",
      calendar.color ?? "unset",
      "important",
    );
    node.style.setProperty(
      "background",
      calendar.color ?? "unset",
      "important",
    );
  };

  const dotStyle = {
    fontSize: "1.7rem",
    color: "#6c757d",
  };

  return (
    <Card
      style={{ width: "20rem", backgroundColor: "#f8f9fa", height: "170px" }}
    >
      <Card.Body>
        <Card.Subtitle className="mb-2 text-muted">{title}</Card.Subtitle>

        <div style={{ paddingLeft: 0, paddingTop: 5 }}>
          {events &&
            events.length > 0 &&
            events?.map((e, i) => {
              return (
                <Row key={i} className="mb-1">
                  <Col>
                    <Stack direction="horizontal">
                      {!common.stringIsNullOrEmpty(e.name) &&
                        moment(e.start_date).isValid() && (
                          <>
                            <Badge
                              ref={(node: HTMLSpanElement) => {
                                applyCalendarColor(node, e.calendar_id);
                              }}
                              bg={bootstrapVariant ?? "secondary"}
                              className="me-2 px-2"
                              style={{
                                fontSize: "0.9rem",
                              }}
                            >
                              {moment(e.start_date).format("DD-MMM")}
                            </Badge>
                            <span
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {e.name}
                            </span>
                          </>
                        )}
                      {(common.stringIsNullOrEmpty(e.name) ||
                        !moment(e.start_date).isValid()) && (
                        <PiDotsThree style={dotStyle} />
                      )}
                    </Stack>
                  </Col>
                </Row>
              );
            })}
          {events?.length === 0 && (
            <Row className="mb-1">
              <Col md={12} style={{ paddingRight: 0 }}>
                <PiDotsThree style={dotStyle} />
              </Col>
              <Col md={12} style={{ paddingRight: 0 }}>
                {/* <div style={{ fontStyle: "italic" }}>No events found.</div> */}
                <PiDotsThree style={dotStyle} />
              </Col>
              <Col md={12} style={{ paddingRight: 0 }}>
                <PiDotsThree style={dotStyle} />
              </Col>
            </Row>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default EventCard;
